import PropTypes from 'prop-types'
import React from 'react'

import './CopyEmail.css'

class CopyEmail extends React.Component {
  constructor(props) {
    super(props)

    this.copyToClipboard = this.copyToClipboard.bind(this);
  }

  copyToClipboard(e) {
    this.textArea.select();
    document.execCommand('copy');
    // This is just personal preference.
    // I prefer to not show the the whole text area selected.
    e.target.focus();
  }

  render() {
    if (!this.props.member || !this.props.emailBodyTpl) {
      return false
    }

    const body = this.props.emailBodyTpl(this.props.member)

    return (
      <div className="CopyEmail">
        <p>If your email program did not open, you can copy the email text, add additional thoughts and send it yourself to <a href={"mailto:" + this.props.member.email}>{this.props.member.email}</a>.</p>
        <div className="CopyEmail-button-container">
          <button onClick={this.copyToClipboard}>Copy Email Text</button>
        </div>
        <form>
          <textarea
            ref={(textarea) => this.textArea = textarea}
            value={body}
            readOnly={true}
          />
        </form>
      </div>
    )

  }
}

CopyEmail.propTypes = {
  member: PropTypes.object,
  emailBodyTpl: PropTypes.func
}

export default CopyEmail



// WEBPACK FOOTER //
// ./src/CopyEmail.js